module.exports = __webpack_public_path__ + "img/rectangle2.94247d5e.jpg";